import React, { useMemo } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["link", "blockquote", "code-block"],
  ["clean"],
];

const FORMATS = [
  "header", "bold", "italic", "underline", "strike",
  "color", "background", "list", "align",
  "link", "blockquote", "code-block",
];

export default function RichEditor({ value, onChange, placeholder = "Type your note…", height = 180, testid = "rich-editor" }) {
  const modules = useMemo(() => ({ toolbar: TOOLBAR }), []);
  return (
    <div className="aulelo-quill" data-testid={testid} style={{ minHeight: height }}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
      />
      <style>{`
        .aulelo-quill .ql-toolbar.ql-snow {
          background: #0a0a0a;
          border: 1px solid rgba(16, 185, 129, 0.25);
          border-bottom: none;
          border-radius: 0;
        }
        .aulelo-quill .ql-container.ql-snow {
          background: #000;
          border: 1px solid rgba(16, 185, 129, 0.25);
          border-radius: 0;
          color: #d4d4d8;
          font-family: 'IBM Plex Mono', monospace;
          font-size: 14px;
          min-height: ${height}px;
        }
        .aulelo-quill .ql-editor { min-height: ${height}px; }
        .aulelo-quill .ql-editor.ql-blank::before {
          color: #4b5563;
          font-style: normal;
          font-family: 'IBM Plex Mono', monospace;
        }
        .aulelo-quill .ql-snow .ql-stroke { stroke: #6b7280; }
        .aulelo-quill .ql-snow .ql-fill { fill: #6b7280; }
        .aulelo-quill .ql-snow .ql-picker { color: #6b7280; }
        .aulelo-quill .ql-snow.ql-toolbar button:hover .ql-stroke,
        .aulelo-quill .ql-snow.ql-toolbar button.ql-active .ql-stroke { stroke: #10b981; }
        .aulelo-quill .ql-snow.ql-toolbar button:hover .ql-fill,
        .aulelo-quill .ql-snow.ql-toolbar button.ql-active .ql-fill { fill: #10b981; }
        .aulelo-quill .ql-snow .ql-picker-options { background: #0a0a0a; border-color: rgba(16, 185, 129, 0.25); }
        .aulelo-quill .ql-snow.ql-toolbar button.ql-active, .aulelo-quill .ql-snow .ql-picker-label.ql-active { color: #10b981; }
      `}</style>
    </div>
  );
}
